import { reduxToolkit, urlBuild } from '../../../helpers'

export const moduleName = 'external'
export const performVKMethod = reduxToolkit('PERFORM_VK_METHOD',
	(url: string, params: any) => ({ call: `https://api.vk.com/method/${url}${urlBuild(params)}` }))
